export default __webpack_public_path__ + "9cb95c2872d93a6b95e30a8af3bf1022.png";